import { Routes } from '@angular/router';
import { authGuard } from './shared/guards/auth.guard';

export const routes: Routes = [
    {
        path: 'login',
        title: 'Login',
        loadComponent: () =>
            import('./auth/login/login.component').then((m) => m.LoginComponent),
    },
    {
        path: 'forgot-password',
        title: 'Forgot Password',
        loadComponent: () =>
            import('./auth/forgot-password/forgot-password.component').then((m) => m.ForgotPasswordComponent),
    },
    {
        path: 'reset-password',
        title: 'Reset Password',
        loadComponent: () =>
            import('./auth/reset-password/reset-password.component').then((m) => m.ResetPasswordComponent),
    },
    {
        path: 'set-password',
        title: 'Set Password',
        loadComponent: () =>
            import('./auth/reset-password/reset-password.component').then((m) => m.ResetPasswordComponent),
    },
    {
        path: '',
        canActivate: [authGuard],
        loadChildren: () => import('./layout/layout.routes').then(m => m.layoutRoutes)
    },
];
